import { OnEventDispatcher } from "../core/on-event-dispatcher";
import { VaxiluskernaMap } from "./vaxiluskernamap";
import { WorldGeomCountry } from "../io/worldgeom";

export type VaxiluskernaCountryOptions = {
    geomCountry: WorldGeomCountry

}
export class VaxiluskernaCountry extends OnEventDispatcher {
    map: VaxiluskernaMap;
    options: VaxiluskernaCountryOptions;

    polygon: google.maps.Polygon;
    bounds: google.maps.LatLngBounds;

    selected: boolean = false;
    hovered: boolean;
    _opacity:number = 1;
    hidden:boolean = false;
    peripheral:boolean = false;
    
    constructor(map:VaxiluskernaMap, options:VaxiluskernaCountryOptions) {
        
        super();
        this.map = map;
        this.options = options;

        let drawGeomRes = this.map.googlemaps.drawGeom(options.geomCountry.geometry);
        this.polygon = drawGeomRes.poly;
        this.bounds = drawGeomRes.bounds;

        this.polygon.addListener("mouseover", () => {
            this.hovered = true;
            this.map.showTooltip(this.options.geomCountry.name + ", " + this.options.geomCountry.parent.name);
            this.updatePolygon();
        });
        this.polygon.addListener("mouseout", () => {
            this.hovered = false;
            this.map.hideTooltip();
            this.updatePolygon();
        });
        this.polygon.addListener("click", () => {
            console.log("click " + this.peripheral);
            this.dispatch("click");
        });

        this.options.geomCountry.vaxiCountry = this;

        this.updatePolygon();
    }

    updatePolygon() {
        if(this.selected) {
            this.polygon.setOptions({
                fillColor: "#fff",
                fillOpacity: 0.5,
                strokeColor: "#000000",
                strokeOpacity: 0.1,
                strokeWeight: 1
            });
        } else {
            if(this.peripheral) {
                if(this.hovered) {
                    this.polygon.setOptions({
                        fillColor: "#fff",
                        fillOpacity: 0.4,
                        strokeColor: "#000000",
                        strokeOpacity: 0.1,
                        strokeWeight: 1
                    });
                } else {
                    this.polygon.setOptions({
                        fillColor: "#fff",
                        fillOpacity: 0.2,
                        strokeColor: "#000000",
                        strokeOpacity: 0.1,
                        strokeWeight: 1
                    });
                }
            } else {
                if(this.hovered) {
                    this.polygon.setOptions({
                        fillColor: "#fff",
                        fillOpacity: 0.8,
                        strokeColor: "#000000",
                        strokeOpacity: 0.1,
                        strokeWeight: 1
                    });
                } else {
                    this.polygon.setOptions({
                        fillColor: "#fff",
                        fillOpacity: 0.4,
                        strokeColor: "#000000",
                        strokeOpacity: 0.1,
                        strokeWeight: 1
                    });
                }
            }
        }
    }

    setPeripheral(peripheral:boolean) {
        this.peripheral = peripheral;
        this.updatePolygon();
    }
    setSelected(selected:boolean) {
        this.selected = selected;
        this.updatePolygon();
    }

    setHide(hidden:boolean) {
        if(hidden&&!this.hidden) {
            this.hidden = true;
            this.polygon.setMap(null);
        } else if(!hidden&&this.hidden) {
            this.hidden = false;
            this.polygon.setMap(this.map.googlemaps.map);
        }
    }

    destroy() {
        if(this.polygon!=null) {
            this.polygon.setMap(null);
            this.polygon.unbindAll();
            this.polygon = null;
        }
    }
}